/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./common-title.vue?vue&type=template&id=404cffbc&scoped=true"
import script from "./common-title.vue?vue&type=script&lang=js"
export * from "./common-title.vue?vue&type=script&lang=js"
import style0 from "./common-title.vue?vue&type=style&index=0&id=404cffbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404cffbc",
  null
  
)

export default component.exports